import React from 'react';

const Brown = () => {
  return <div>Brown</div>;
};

export default Brown;
